export const SECONDARY_TEXT_COLOR = "var(--wallet-color-neutrals-gray-600)";
